import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PinService {
  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable();

  private newPinSubject = new BehaviorSubject<any>(null);
  newPinData$ = this.newPinSubject.asObservable();

  private blockIdSubject = new BehaviorSubject<any>(null);
  blockIdData$ = this.blockIdSubject.asObservable();

  sendData(data: any) {
    this.dataSubject.next(data);
  }

  sendNewPin(data: any) {
    this.newPinSubject.next(data);
  }

  setBlockId(data: any) {
    this.blockIdSubject.next(data);
  }
}
